import { createFileRoute, Link, useSearch } from "@tanstack/react-router";
import { AgeVerifiedAuth } from "../../components/AgeVerifiedAuth";
import { Header } from "../../components/Header";

type SignUpSearch = {
    redirectTo?: string;
};

export const Route = createFileRoute("/_layout/sign-up")({
    component: SignUp,
    validateSearch: (search: Record<string, unknown>): SignUpSearch => {
        return {
            redirectTo: search.redirectTo as string,
        };
    },
    head: () => ({
        meta: [
            { name: "title", content: "Sign Up - StoryDoodle" },
            {
                name: "description",
                content:
                    "Join StoryDoodle and start creating interactive AI-powered stories with your drawings. Free account for kids ages 5-8 and their families.",
            },
            { name: "robots", content: "noindex, nofollow" },
            { property: "og:title", content: "Sign Up - StoryDoodle" },
            {
                property: "og:description",
                content:
                    "Join StoryDoodle and start creating interactive AI-powered stories with your drawings. Free account for kids ages 5-8 and their families.",
            },
            { property: "og:url", content: "https://storydoodle.app/sign-up" },
        ],
        links: [{ rel: "canonical", href: "https://storydoodle.app/sign-up" }],
    }),
});

function SignUp() {
    const search = useSearch({ from: "/_layout/sign-up" });

    return (
        <div className="min-h-screen page-gradient flex flex-col">
            <Header variant="auth" />
            <div className="flex-1 flex items-center justify-center p-4">
                <div className="w-full max-w-md">
                    <div className="text-center mb-8">
                        <Link to="/" className="inline-block">
                            <h1 className="text-3xl font-bold text-foreground mb-2">StoryDoodle</h1>
                        </Link>
                    </div>
                    <AgeVerifiedAuth
                        view="sign_up"
                        title="Create Account"
                        description="Join StoryDoodle and start creating"
                        redirectTo={
                            search.redirectTo
                                ? `${window.location.origin}${search.redirectTo}`
                                : `${window.location.origin}/`
                        }
                    />
                    <div className="text-center mt-4">
                        <Link to="/sign-in" className="text-sm text-muted-foreground hover:text-foreground underline">
                            Already have an account? Sign in
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
